import React from "react";

import { observer } from "mobx-react";
import { Bet } from "@models";
import { BetDetailsModalStore } from "@state/stores/my-bets/BetDetailsModalStore";
import { useTranslation } from "react-i18next";

import { CombinationItem } from "./combinations-components";
import { BetSlipReceiptModalStore } from "@state/stores/my-bets/BetSlipReceiptModalStore";

export const BetDetailsModalCombinations = observer(
	function BetDetailsModalCombinations(props: {
		bet: Bet;
		isActive: boolean;
		store: BetDetailsModalStore | BetSlipReceiptModalStore;
	}) {
		const { bet, isActive, store } = props;
		const { t } = useTranslation();

		if (!isActive) {
			return null;
		}

		const combinations = store.betCombinationsMap.get(bet.id);

		return (
			<div className="table--responsive">
				<table className="table--bet u-bg--transparent">
					<thead className="table--bet__header">
						<tr className="table--bet__header__row">
							<th className="table--bet__header__data">
								{t(
									"mybets:ITEM.BET_SLIP_COMBINATIONS.ORDINAL_NUMBER"
								)}
							</th>
							<th className="table--bet__header__data">
								{t(
									"mybets:ITEM.BET_SLIP_COMBINATIONS.COMBINATION"
								)}
							</th>
							<th className="table--bet__header__data">
								{t(
									"mybets:ITEM.BET_SLIP_COMBINATIONS.TOTAL_QUOTA"
								)}
							</th>
							<th className="table--bet__header__data">
								{t("ACC_STATEMENT.TABLES.STATUS")}
							</th>
						</tr>
					</thead>
					<tbody>
						{bet.combinationBettingOffersCount > 1 &&
							combinations !== null &&
							// @ts-expect-error
							combinations.map((combination, index) => (
								<CombinationItem
									combination={combination}
									key={index}
									ordinalNumber={index + 1}
								/>
							))}
					</tbody>
				</table>
			</div>
		);
	}
);
